__turbopack_context__.v({
  "author": "Customer-module-scss-module__7W2QHW__author",
  "companyLink": "Customer-module-scss-module__7W2QHW__companyLink",
  "text": "Customer-module-scss-module__7W2QHW__text",
});
